const blockSliderHero = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const blocks = document.querySelectorAll(".block-slider-hero__section");
    if (blocks.length > 0) {
      blocks.forEach((block) => {
        const slider = new Swiper(block, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: block.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      });
    }
  });
};

export default blockSliderHero;
